<div class="section">
  <div class="chart">
    <!-- <div class="graph_">
       <h2>{{Title}}</h2>
       <h4>{{Title}} collected from different platforms</h4>
     </div> -->

    <div>
      <div class="title">{{Title}}</div>
      <div class="sub-title">{{Title}} collected from different platforms</div>
    </div>

    <!-- <div class="circle_graph_right">
      <div class="h-social-img">
        <img src="assets/tina-social.png" alt="" />
  
        <circle-progress
          [percent]="circleValues.tina"
          [space]="-10"
          [radius]="30"
          [outerStrokeColor]="'#4882c2'"
          [innerStrokeColor]="'#e7e8ea'"
          [animation]="true"
          [animationDuration]="1000"
        ></circle-progress>
      </div>

      <div class="h-social-img">
        <img src="assets/logos_whatsapp-icon.png" alt="" />
        
        <circle-progress
        [percent]="circleValues.whatsapp"
          [space]="-10"
          [radius]="30"
          [outerStrokeColor]="'#4882c2'"
          [innerStrokeColor]="'#e7e8ea'"
          [animation]="true"
          [animationDuration]="1000"
        ></circle-progress>
      </div>
      <div class="h-social-img">
        <img src="assets/create.png" alt="" />
        <circle-progress
          [percent]="circleValues.manual"
          [space]="-10"
          [radius]="30"
          [outerStrokeColor]="'#4882c2'"
          [innerStrokeColor]="'#e7e8ea'"
          [animation]="true"
          [animationDuration]="1000"
        ></circle-progress>
      </div>
     </div> -->
  </div>
  <div class="chart-container">
    <canvas [id]="id" width="350" height="320"></canvas>
  </div>


  <div class="flex flex-wrap -mx-2 mt-5">

    <div class="w-full md:w-1/3 px-2 mb-1 ">

      <div class="flex items-center mb-2 line-bar-heading">
        <div>
          <img src="assets/tina-social.png" alt="" class="line-bar-img" />
        </div>
        <div class="ml-2 line-bar-text">
          Tina
        </div>
      </div>

      <div>
        <div class="line_bar" [ngStyle]="{
        'background': 'linear-gradient(to right, #0099FF ' + circleValues.tina + '%, #F0F0F0 ' + circleValues.tina + '% 100%)',
        'height.px': 22
      }">
          <div class="liner-value" [style.margin-left.px]="circleValues.tina > 12 ? circleValues.tina - 10 : 0">
            {{ circleValues.tina | number:'1.2-2' }}%
          </div>
        </div>
      </div>

    </div>

    <div class="w-full md:w-1/3 px-2 mb-1">

      <div class="flex items-center mb-2 line-bar-heading">
        <div>
          <img src="assets/logos_whatsapp-icon.png" alt="" class="line-bar-img" />
        </div>
        <div class="ml-2 line-bar-text">
          WhatsApp
        </div>
      </div>

      <div>
        <div class="line_bar" [ngStyle]="{
        'background': 'linear-gradient(to right, #77DC75 ' + circleValues.whatsapp + '%, #F0F0F0 ' + circleValues.whatsapp + '% 100%)',
        'height.px': 22
      }">
          <div class="liner-value" [style.margin-left.px]="circleValues.whatsapp">
            {{ circleValues.whatsapp | number:'1.2-2' }}%
          </div>
        </div>
      </div>

    </div>

    <div class="w-full md:w-1/3 px-2 mb-1">

      <div class="flex items-center mb-2 line-bar-heading">
        <div>
          <img src="assets/create.png" alt="" class="line-bar-img" />
        </div>
        <div class="ml-2 line-bar-text">
          Others
        </div>
      </div>

      <div>
        <div class="line_bar" [ngStyle]="{
        'background': 'linear-gradient(to right, #F0950C ' + circleValues.manual + '%, #F0F0F0 ' + circleValues.manual + '% 100%)',
        'height.px': 22
      }">
          <div class="liner-value">
            {{ circleValues.manual | number:'1.2-2' }}%
          </div>
        </div>
      </div>

    </div>

  </div>

</div>